import { ConnectionDetails, convertConnectionToDetails, handleError, mergeConnectionDetails } from '@/utils/custom';
import { TimeFrameRange, TimeFrameRangeConnection, TimeFrameRangeConnectionInput, TimeFrameRangeSearch } from '@/models/gen/graphql';

import { GraphApiResponse } from '@/api/core';
import { SearchTimeFrameRangeDocument } from '@/api/queries';
import createGraphApiHook from '@/hooks/createGraphApiHook';
import graphApi from '@/api';

export type SearchTimeFrameRangeGraphApiResponse = GraphApiResponse<typeof SearchTimeFrameRangeDocument>;
export type SearchTimeFrameRangeOptions = { pageSize?: number; page?: number; merge?: true };

export const SEARCH_TIME_FRAME_RANGE_PAGE_SIZE = 1000;
const title = 'Search Time Frame Range';

export const searchTimeFrameRangeResponseSelector = (res: SearchTimeFrameRangeGraphApiResponse): ConnectionDetails<TimeFrameRange> =>
  convertConnectionToDetails(res?.searchTimeFrameRange?.timeFrameRangeConnection as TimeFrameRangeConnection);

const [runSearchTimeFrameRange, runRefetchSearchTimeFrameRange] = graphApi(SearchTimeFrameRangeDocument, {
  onError: (res: SearchTimeFrameRangeGraphApiResponse): void => handleError(res, { notification: { title } }),
});

const searchTimeFrameRange = async (
  query?: TimeFrameRangeSearch[],
  options: SearchTimeFrameRangeOptions = {}
): Promise<ConnectionDetails<TimeFrameRange>> => {
  const { pageSize = SEARCH_TIME_FRAME_RANGE_PAGE_SIZE, page = 0, merge = false } = options;

  const input: TimeFrameRangeConnectionInput = {
    first: pageSize || null,
    after: pageSize ? (pageSize * page).toString() : null,
    query,
  };
  const graphApiOptions = { merge: merge ? 'searchTimeFrameRange.timeFrameRangeConnection' : undefined };

  const res = await runSearchTimeFrameRange({ input }, graphApiOptions);

  return searchTimeFrameRangeResponseSelector(res);
};

export const refetchSearchTimeFrameRange = async (
  query?: TimeFrameRangeSearch[],
  options: SearchTimeFrameRangeOptions = {}
): Promise<ConnectionDetails<TimeFrameRange>> => {
  const { pageSize = SEARCH_TIME_FRAME_RANGE_PAGE_SIZE, page = 0 } = options;

  const input: TimeFrameRangeConnectionInput = {
    first: pageSize || null,
    after: pageSize ? (pageSize * page).toString() : null,
    query,
  };

  const res = await runRefetchSearchTimeFrameRange({ input });

  return searchTimeFrameRangeResponseSelector(res);
};

export const useSearchTimeFrameRange = createGraphApiHook(searchTimeFrameRange, {
  refetch: refetchSearchTimeFrameRange,
  merge: mergeConnectionDetails,
});

export default searchTimeFrameRange;
